import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formPanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  backLink: {
    color: theme.palette.custom.primary1,
    fontWeight: 500,
    fontSize: 16,
    paddingLeft: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    color: theme.palette.custom.primary1,
    fontWeight: 500,
  },
  checkbox: {
    color: 'rgba(150, 150, 150, 0.6)',
    '&.Mui-checked': {
      color: '#162C5F',
    },
  },
  emailInput: {
    '& .MuiInputBase-input': {
      textTransform: 'lowercase',
    },
  },
}));

export default useStyles;
